import * as React from 'react';

const QuoteImageBlock = React.lazy(
  () =>
    import(
      /* webpackChunkName: "QuoteImageBlock-Chunk" */ './organisms/QuoteImageBlock/QuoteImageBlockWrapper'
    ),
);

const TechnicalDownloadSearch = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TechnicalDownloadSearch-Chunk" */ './organisms/TechnicalDownloadSearch/TechnicalDownloadSearchWrapper'
    ),
);

const PageTitle = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PageTitle-Chunk" */ './organisms/PageTitle/PageTitleWrapper'
    ),
);

const ImageGallery = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ImageGallery-Chunk" */ './organisms/ImageGallery/ImageGalleryWrapper'
    ),
);

const HeadlineAndText = React.lazy(
  () =>
    import(
      /* webpackChunkName: "HeadlineAndText-Chunk" */ './organisms/HeadlineAndTextBlock/HeadlineAndTextBlockWrapper'
    ),
);

const TextBlock = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TextBlock-Chunk" */ './organisms/TextBlock/TextBlockWrapper'
    ),
);

const ContactGrid = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContactGrid-Chunk" */ './organisms/ContactGrid/ContactGridWrapper'
    ),
);

const ContentCards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContentCards-Chunk" */ './organisms/ContentCards/ContentCardsWrapper'
    ),
);

const Footer = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Footer-Chunk" */ './organisms/Footer/FooterWrapper'
    ),
);

const FullWidthMedia = React.lazy(
  () =>
    import(
      /* webpackChunkName: "FullWidthMedia-Chunk" */ './organisms/FullWidthMedia/FullWidthMediaWrapper'
    ),
);

const Header = React.lazy(
  () =>
    import(/* webpackChunkName: "Header" */ './organisms/Header/HeaderWrapper'),
);

const MyDocuments = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MyDocuments-Chunk" */ './organisms/MyDocuments/MyDocuments'
    ),
);

const DashboardBanner = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DashboardBanner-Chunk" */ './organisms/DashboardBanner/DashboardBanner'
    ),
);

const HighlightModule = React.lazy(
  () =>
    import(
      /* webpackChunkName: "HighlightModule-Chunk" */ './organisms/HighlightModule/HighlightModuleWrapper'
    ),
);

// Back-End work not yet compelted on B2B
const StorytellingModule = React.lazy(
  () =>
    import(
      /* webpackChunkName: "StorytellingModule-Chunk" */ './organisms/StorytellingModule/StorytellingModuleWrapper'
    ),
);

const Breadcrumb = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Breadcrumb-Chunk" */ './organisms/Breadcrumb/BreadcrumbWrapper'
    ),
);

const BrandsAndSolutionsListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "BrandsAndSolutionsListing-Chunk" */ './organisms/BrandsAndSolutionsListing/BrandsAndSolutionsListing'
    ),
);

const ServiceAccordion = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ServiceAccordion-Chunk" */ './organisms/ServiceAccordion/ServiceAccordionWrapper'
    ),
);

const SectionMarkerBlock = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SectionMarkerBlock-Chunk" */ './organisms/SectionMarkerBlock/SectionMarkerBlockWrapper'
    ),
);

const SimpleTable = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SimpleTable-Chunk" */ './organisms/SimpleTable/SimpleTableWrapper'
    ),
);

const HeadlineAccordion = React.lazy(
  () =>
    import(
      /* webpackChunkName: "HeadlineAccordion-Chunk" */ './organisms/HeadlineAccordion/HeadlineAccordion'
    ),
);

const IconCards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "IconCards-Chunk" */ './organisms/IconCardBlock/IconCardBlock'
    ),
);

const MediaHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MediaHero-Chunk" */ './organisms/MediaHero/MediaHeroWrapper'
    ),
);

const ImageCardBlock = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ImageCardBlock-Chunk" */ './organisms/ImageCardBlock/ImageCardBlock'
    ),
);

const MarketingDownload = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MarketingDownload-Chunk" */ './organisms/MarketingDownload/MarketingDownload'
    ),
);

const LinkCard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LinkCard-Chunk" */ './organisms/LinkCardBlock/LinkCardBlockWrapper'
    ),
);

const ChildPageNavigation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ChildPageNavigation-Chunk" */ './organisms/ChildPageNavigation/ChildPageNavigation'
    ),
);

const ArticleHeader = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ArticleHeader-Chunk" */ './organisms/ArticleHeader/ArticleHeaderWrapper'
    ),
);

const ContactCards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContactCards-Chunk" */ './organisms/ContactCards/ContactCardsWrapper'
    ),
);

const ArticleStamp = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ArticleStamp-Chunk" */ './organisms/ArticleStamp/ArticleStampWrapper'
    ),
);

const DownloadCards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "DownloadCards-Chunk" */ './organisms/DownloadCards/DownloadCardsWrapper'
    ),
);

const ArticleTags = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ArticleTags-Chunk" */ './organisms/ArticleTags/ArticleTagsWrapper'
    ),
);

const Pagination = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Pagination-Chunk" */ './organisms/Pagination/Pagination'
    ),
);

const ArticleMedia = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ArticleMedia-Chunk" */ './organisms/ArticleMedia/ArticleMedia'
    ),
);

const NewsAndInsightsListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NewsAndInsightsListing-Chunk" */ './organisms/NewsAndInsightsListing/NewsAndInsightsListingWrapper'
    ),
);

const NewsAndInsightsFeatured = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NewsAndInsightsFeatured-Chunk" */ './organisms/NewsAndInsightsFeatured/NewsAndInsightsFeaturedWrapper'
    ),
);

const NewsListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NewsListing-Chunk" */ './organisms/NewsListing/NewsListing'
    ),
);

const LoyaltyRewardDetails = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LoyaltyRewardDetails-Chunk" */ './organisms/LoyaltyRewardDetails/LoyaltyRewardDetails'
    ),
);

const LoyaltyRewardListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LoyaltyRewardListing-Chunk" */ './organisms/LoyaltyListing/LoyaltyListing'
    ),
);

const ContentExpander = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContentExpander-Chunk" */ './organisms/ContentExpander/ContentExpanderWrapper'
    ),
);

const Campaign = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Campaign-Chunk" */ './organisms/CampaignBlock/CampaignBlockWrapper'
    ),
);

const LocationSearch = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LocationSearch-Chunk" */ './organisms/LocationListing/LocationListing'
    ),
);

const CpContactForm = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CpContactForm-Chunk" */ './organisms/MyJotunContactUsForm/MyJotunContactUsForm'
    ),
);

const BecomeASupplierForm = React.lazy(
  () =>
    import(
      /* webpackChunkName: "BecomeASupplierForm-Chunk" */ './organisms/BecomeASupplierForm/BecomeASupplierForm'
    ),
);

const BecomeADealerForm = React.lazy(
  () =>
    import(
      /* webpackChunkName: "BecomeADealerForm-Chunk" */ './organisms/BecomeADealerForm/BecomeADealerForm'
    ),
);

const ContactForm = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ContactForm-Chunk" */ './organisms/ContactUsForm/ContactUsForm'
    ),
);

const InteractiveImage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "InteractiveImage-Chunk" */ './organisms/InteractiveImage/InteractiveImage'
    ),
);

const CaseStudyHeader = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CaseStudyHeader-Chunk" */ './organisms/CaseStudyHeader/CaseStudyHeader'
    ),
);

const ColourListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ColourListing-Chunk" */ './organisms/ColourListing/ColourListing'
    ),
);

const ProductCard = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductCard-Chunk" */ './organisms/ProductTile/ProductTileWrapper'
    ),
);

const ProductHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductHero-Chunk" */ './organisms/ProductHero/ProductHero'
    ),
);

const ProductCardBlock = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductCardBlock-Chunk" */ './organisms/ArticleProductBlock/ArticleProductBlockWrapper'
    ),
);

const Palette = React.lazy(
  () =>
    import(
      /* webpackChunkName: "Palette-Chunk" */ './organisms/Palette/Palette'
    ),
);

const RelatedProducts = React.lazy(
  () =>
    import(
      /* webpackChunkName: "RelatedProducts-Chunk" */ './organisms/RelatedProducts/RelatedProducts'
    ),
);

const MyListListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "MyListListing-Chunk" */ './organisms/MyListListing/MyListListing'
    ),
);

const MyList = React.lazy(
  () =>
    import(/* webpackChunkName: "MyList-Chunk" */ './organisms/MyList/MyList'),
);

const ProductListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductListing-Chunk" */ './organisms/ProductListing/ProductListing'
    ),
);

const TwoColumnHotspotColourImage = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TwoColumnHotspotColourImage-Chunk" */ './organisms/TwoColumnHotspotColourImage/TwoColumnHotspotColourImageWrapper'
    ),
);

const ProductHeroV2 = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductHeroV2-Chunk" */ './organisms/ProductHeroV2/ProductHeroV2'
    ),
);

const AnchorMenu = React.lazy(
  () =>
    import(
      /* webpackChunkName: "AnchorMenu-Chunk" */ './organisms/AnchorMenu/AnchorMenuWrapper'
    ),
);

const ProductAbout = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductAbout-Chunk" */ './organisms/ProductAbout/ProductAbout'
    ),
);

const ProductDownloads = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductDownloads-Chunk" */ './organisms/ProductDownloads/ProductDownloads'
    ),
);

const ProductKeyFeatures = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ProductKeyFeatures-Chunk" */ './organisms/ProductKeyFeatures/ProductKeyFeatures'
    ),
);

const GlobalNavigation = React.lazy(
  () =>
    import(
      /* webpackChunkName: "GlobalNavigation-Chunk" */ './organisms/NewGlobalNav/NewGlobalNavWrapper'
    ),
);

const HomepageHero = React.lazy(
  () =>
    import(
      /* webpackChunkName: "HomepageHero-Chunk" */ './organisms/HomepageHero/HomepageHero'
    ),
);

const LargeImageCarousel = React.lazy(
  () =>
    import(
      /* webpackChunkName: "LargeImageCarousel-Chunk" */ './organisms/LargeImageCarousel/LargeImageCarousel'
    ),
);

const KeyStatistics = React.lazy(
  () =>
    import(
      /* webpackChunkName: "KeyStatistics-Chunk" */ './organisms/KeyStatistics/KeyStatistics'
    ),
);

const KeyFiguresBlock = React.lazy(
  () =>
    import(
      /* webpackChunkName: "KeyFiguresBlock-Chunk" */ './organisms/KeyFiguresBlock/KeyFiguresBlockWrapper'
    ),
);

const NavigationGrid = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NavigationGrid-Chunk" */ './organisms/NavigationGrid/NavigationGrid'
    ),
);

const NotFoundContentCards = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NotFoundContentCards-Chunk" */ './organisms/NotFoundContentCards/NotFoundContentCardsWrapper'
    ),
);

const TimelineBlock = React.lazy(
  () =>
    import(
      /* webpackChunkName: "TimelineBlock-Chunk" */ './organisms/TimelineBlock/TimelineBlock'
    ),
);

const GlobalSettings = React.lazy(
  () =>
    import(
      /* webpackChunkName: "GlobalSettings-Chunk" */ './organisms/GlobalSettings/GlobalSettingsWrapper'
    ),
);

const NewsletterSignup = React.lazy(
  () =>
    import(
      /* webpackChunkName: "NewsletterSignup-Chunk" */ './organisms/NewsletterSignup/NewsletterSignupWrapper'
    ),
);

const ChildPageNavigationV2 = React.lazy(
  () =>
    import(
      /* webpackChunkName: "ChildPageNavigationV2-Chunk" */ './organisms/ChildPageNavigationV2/ChildPageNavigationV2'
    ),
);

const PaginationV2 = React.lazy(
  () =>
    import(
      /* webpackChunkName: "PaginationV2-Chunk" */ './organisms/PaginationV2/PaginationV2'
    ),
);

const CollectionListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "CollectionListing-Chunk" */ './organisms/CollectionListing/CollectionListing'
    ),
);

const HotspotFeature = React.lazy(
  () =>
    import(
      /* webpackChunkName: "HotspotFeature-Chunk" */ './organisms/HotspotFeatureWrapper/HotspotFeatureWrapper'
    ),
);

const SearchListing = React.lazy(
  () =>
    import(
      /* webpackChunkName: "SearchListing-Chunk" */ './organisms/SearchListing/SearchListing'
    ),
);

const KeyFeatures = React.lazy(
  () =>
    import(
      /* webpackChunkName: "KeyFeatures-Chunk" */ './organisms/KeyFeatures/KeyFeaturesWrapper'
    ),
);
// Use format <BE Component Name>: <FE Component Name> if the component names differ.

export default {
  AnchorMenu,
  ArticleHeader,
  ArticleMedia,
  ArticleStamp,
  ArticleTags,
  BecomeASupplierForm,
  BecomeADealerForm,
  BrandsAndSolutionsListing,
  Breadcrumb,
  Campaign,
  CaseStudyHeader,
  ChildPageNavigation,
  ChildPageNavigationV2,
  ColourListing,
  CollectionListing,
  ContactCards,
  ContactGrid,
  ContentCards,
  ContentExpander,
  ContactForm,
  CpContactForm,
  DashboardBanner,
  DocumentManagementBlock: MyDocuments,
  DownloadCards,
  GlobalNavigation,
  Footer,
  FullWidthMedia,
  GlobalSettings,
  Header,
  HeadlineAccordion,
  HeadlineAndText,
  HighlightModule,
  HomepageHero,
  HotspotFeature,
  IconCards,
  ImageCardBlock,
  ImageGallery,
  InteractiveImage,
  KeyFiguresBlock,
  KeyFeatures,
  KeyStatistics,
  LargeImageCarousel,
  LinkCard,
  LocationSearch,
  LoyaltyRewardDetails,
  MarketingDownload,
  MediaHero,
  MyListListing,
  MyList,
  NavigationGrid,
  NewsListing,
  NewsletterSignup,
  NewsAndInsightsFeatured,
  NewsAndInsightsListing,
  NotFoundContentCards,
  PageTitle,
  Pagination,
  PaginationV2,
  Palette,
  ProductAbout,
  ProductCard,
  ProductCardBlock,
  ProductDownloads,
  ProductHero,
  ProductHeroV2,
  ProductKeyFeatures,
  ProductListing,
  QuoteImageBlock,
  RelatedProducts,
  RewardListing: LoyaltyRewardListing,
  SearchListing,
  SectionMarkerBlock,
  ServiceAccordion,
  SimpleTable,
  StorytellingModule,
  TechnicalDownloadSearch,
  TextBlock,
  TimelineBlock,
  TwoColumnHotspotColourImage,
};
